module.exports = __webpack_public_path__ + "static/detalhesPonto-f6d0fe0b9c120ed4efb5f83fc860634b.png";